import React from "react";
import { css } from "@emotion/react";
import { useRecoilState } from "recoil";
import { ChatWidgetState, ChatWidgetStateType } from "recoil/chat";
import ChatWidget from "components/chat/widget/ChatWidget";

// mui
import Stack from "@mui/material/Stack";

const style = {
  root: css`
    position: fixed;
    bottom: 0;
    right: 80px;
    z-index: 100;
  `,
};
const ChatWidgets: React.FC = () => {
  const [guids, setWidgetOpenedGUIDs] = useRecoilState<ChatWidgetStateType>(ChatWidgetState);

  const closeWidget = (guid: string) => {
    setWidgetOpenedGUIDs(guids.filter((openedGUID) => openedGUID != guid));
  };

  return (
    <div css={style.root}>
      <Stack direction="row" spacing={2}>
        {guids.map((guid) => (
          <ChatWidget key={guid} guid={guid} handleClose={closeWidget} />
        ))}
      </Stack>
    </div>
  );
};

export default ChatWidgets;
